import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEmpirekredComponent } from './simple-icons-empirekred.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEmpirekredComponent ],
    exports:      [ SimpleIconsEmpirekredComponent ],
    bootstrap:    []
})
export class SimpleIconsEmpirekredModule {}
